import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentPage: 0,
  details: {
    doctorName: 'Lab Appointment',
    doctorId: '',
    userName: null,
    userMobile: null,
    userAge: null,
    userTitle: null,
    userEmail: null,
    userGender: null,
    cp_id: null,
    slotTiming: null,
    amount: null,
    appointmentType: 'LAB',
  },
}

const LabAppointmentSlice = createSlice({
  name: 'labAppointment',
  initialState,
  reducers: {
    selectLabSlot(state, action) {
      state.details.slotTiming = action.payload
      state.currentPage = 1
    },
    clearLabSlot(state) {
      state.details.slotTiming = null
      state.currentPage = 0
    },
    addLabPatientDetails(state, action) {
      state.details.userAge = action.payload.userAge
      state.details.userName = `${action.payload.title} ${action.payload.name}`
      state.details.userMobile = action.payload.mobile
      state.details.userTitle = action.payload.title
      state.details.userGender = action.payload.gender
      state.details.userEmail = action.payload.email
      state.currentPage = 1
    },
    backLabStep(state) {
      state.currentPage = Math.max(state.currentPage - 1, 0)
    },
    resetLabAppointmentState: () => initialState,
  },
})

export const { selectLabSlot, clearLabSlot, addLabPatientDetails, backLabStep, resetLabAppointmentState } =
  LabAppointmentSlice.actions

export default LabAppointmentSlice.reducer
